import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic', 'image/heif'];
export const MAX_IMAGE_MB = 20;

export async function uploadToCloudinary(file, { resourceType = 'image', folder = 'products', onProgress } = {}) {
  const { data: sig } = await axios.get(`${API}/cloudinary/signature`, {
    params: { folder, resource_type: resourceType },
  });
  const body = new FormData();
  body.append('file', file);
  body.append('api_key', sig.api_key);
  body.append('timestamp', sig.timestamp);
  body.append('signature', sig.signature);
  body.append('folder', sig.folder);
  const { data } = await axios.post(
    `https://api.cloudinary.com/v1_1/${sig.cloud_name}/${resourceType}/upload`,
    body,
    {
      withCredentials: false,
      onUploadProgress: (ev) => onProgress && ev.total && onProgress(Math.round((ev.loaded / ev.total) * 100)),
    }
  );
  return resourceType === 'image'
    ? data.secure_url.replace('/image/upload/', '/image/upload/f_auto,q_auto/')
    : data.secure_url;
}

export const uploadErrorMessage = (err) =>
  err?.response?.data?.error?.message || err?.response?.data?.detail || 'Upload failed. Please try again.';
